import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import theme from "styles/theme";
import { IAllocationDimension } from "helpers/allocation-dimension";
import Close from "components/icons/close";
import { DATATEST } from "constants/integration";
import { styles } from "./manage-allocation-dimension-styles";

interface IProps {
    allocationDimension: IAllocationDimension;
    onToggleShow: () => void;
    isSaving?: boolean;
    isRollupMode: boolean;
}
export const ManageAllocationDimensionTitle: React.FunctionComponent<IProps> = ({
    onToggleShow,
    isSaving,
    isRollupMode,
}) => {
    return (
        <div {...styles.modalActions} className="actions">
            <div className="titleLeft">
                <h4 className="modalTitle" data-test={DATATEST.ASSORTMENTS.ALLOCATION_DIMENSIONS.MODAL_TITLE}>
                    {isRollupMode ? formatMessage("Door Attributes") : formatMessage("Manage Door Attributes")}
                </h4>
            </div>
            <div className="titleRight">
                {isSaving && <div className="isSavingText">{formatMessage("saving changes")}</div>}
                <Close
                    data-test={DATATEST.ASSORTMENTS.DETAILS_CLOSE_BTN}
                    key="close"
                    onClick={onToggleShow}
                    color={theme.palette.darkerGrey}
                />
            </div>
        </div>
    );
};
